// @ts-check
import React, { createContext } from 'react'
import { Label } from '../Label/Label'
import styles from './style.css'

const { Provider, Consumer } = createContext({
  name: 'radio',
  selectedValue: '',
  onChange: (e) => {}
})

/**
 * @param {{
 * name: string,
 * selectedValue: string,
 * label: string,
 * onChange: {(event: React.ChangeEvent): void},
 * children: React.ReactChild,
 * Component: string | Function | Object,
 * valid: boolean,
 * showLabel: boolean }} props
 */
const IdScanRadioGroup = ({
  Component,
  label,
  name,
  selectedValue,
  onChange,
  children,
  valid,
  showLabel,
  ...rest
}) => (
  <Provider value={{ name, selectedValue, onChange }}>
    <div className={styles.field}>
      {showLabel && <Label htmlFor={label} value={label} valid={valid} />}
      <Component className={styles.radioGroup} role='radiogroup' {...rest}>
        {children}
      </Component>
    </div>
  </Provider>
)
IdScanRadioGroup.defaultProps = {
  Component: 'div',
  label: 'Choose'
}

/**
 * @param {{ title: string, value: string }} props
 */
const Radio = ({ title, value }) => (
  <Consumer>
    {({ name, selectedValue, onChange }) => (
      <label className={styles.radio}>
        <span className={`${styles.icon} ${value === selectedValue ? styles.checked : ''}`} />
        <input
          value={value}
          checked={value === selectedValue}
          type='radio'
          name={name}
          onChange={onChange}
          className={styles.input}
        />
        <span className={styles.title}>{title}</span>
      </label>
    )}
  </Consumer>
)

export { Radio, IdScanRadioGroup }
